import { useEffect } from "react";
import { useSocketInstance } from "../context/SocketContext";

/**
 * Hook to listen to a Socket.io event.
 * Automatically cleans up the listener on unmount.
 *
 * @param {string} event - The event name (e.g., 'call:incoming')
 * @param {Function} handler - The callback function
 */
export function useSocketEvent(event, handler) {
  // Just the socket: the full context changes on every presence update and a
  // minute tick, which re-rendered every page listening for an event.
  const socket = useSocketInstance();

  useEffect(() => {
    if (!socket || !event || !handler) return;

    socket.on(event, handler);
    return () => {
      socket.off(event, handler);
    };
  }, [socket, event, handler]);
}
